module.exports = __webpack_public_path__ + "static/media/bitkeep-wallet.1f96a77d.png";